module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.type) ? _c('aside', {
    staticClass: "sidebar",
    class: {
      'sidebar--tabs': _vm.type == 'tabs',
        'sidebar--fixed': _vm.type == 'fixed',
        'sidebar--flex': _vm.type == 'flex',

        'top': _vm.position == 'top' && _vm.type == 'flex',
        'bottom': _vm.position == 'bottom' && _vm.type == 'flex',
    }
  }, [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-827aef66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Sidebar.vue
// module id = 571
// module chunks = 225